import { ALLOW_SAVING_FILTERS_IN_SEARCH_240415 } from "@faire/web-api/indigofair/settings/ALLOW_SAVING_FILTERS_IN_SEARCH_240415";

import {
  getSettingValueAndAssign,
  getSettingValueWithoutAssignment,
} from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingAndAssignSavedSearchFilters = (): boolean => {
  return getSettingValueAndAssign(ALLOW_SAVING_FILTERS_IN_SEARCH_240415, false);
};

export const getSettingWithoutAssignmentSavedSearchFilters = (): boolean => {
  return getSettingValueWithoutAssignment(
    ALLOW_SAVING_FILTERS_IN_SEARCH_240415,
    false
  );
};
